(() => {
  const enhance = () => {
    document.querySelectorAll('.whatsapp-floating-button:not([data-mdf-keyboard])').forEach(button => {
      button.dataset.mdfKeyboard = 'true';
      if (button.tagName === 'BUTTON' || button.tagName === 'A') return;
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'Chat on WhatsApp');
      button.addEventListener('keydown', event => {
        if ((event.key === 'Enter' || event.key === ' ') && !event.repeat) {
          event.preventDefault();
          button.click();
        }
      });
    });
  };
  enhance();
  new MutationObserver(enhance).observe(document.body, {childList:true, subtree:true});
})();

